import { Comment } from "../../../../../models"

export interface CommentResponse extends Omit<Comment, 'commentId'> {
    key: string
}

export const proccessSingleCommentResponse = (response: CommentResponse): Comment => {
    const cloneResponse = { ...response }
    delete cloneResponse.key

    return {
        ...cloneResponse,
        tempId: response.tempId ?? null,
        commentId: response.key
    }
}

export const processCommentsResponse = (commentsResponse: CommentResponse[]): Comment[] => {
    return commentsResponse.map(proccessSingleCommentResponse)
}